import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { SavedRepliesSortEnum } from 'entities/CannedMessages/store/types'
import { type UsersStore } from 'entities/Users'

export class CannesMessageStore {
  private _disposeReactionOrderUpdate: IReactionDisposer | null = null
  private _disposeReactionOrderRestore: IReactionDisposer | null = null

  constructor(private _usersStore: UsersStore) {
    makeAutoObservable(this)
    this.reactionOrderRestore()
    this.reactionOrderUpdate()
  }

  order: SavedRepliesSortEnum = SavedRepliesSortEnum.newest

  get storageKey() {
    if (!this._usersStore.user) return ''

    return `${this._usersStore.user.id}_cannedMessage_order`
  }

  setOrder = (order: SavedRepliesSortEnum) => {
    this.order = order
  }

  storeOrder = () => {
    if (!this._usersStore.user) return

    window.localStorage.setItem(this.storageKey, this.order)
  }

  restoreOrder = () => {
    if (!this._usersStore.user) return
    const storedOrder = window.localStorage.getItem(this.storageKey)

    if (!storedOrder) return
    this.order = storedOrder as SavedRepliesSortEnum
  }

  reactionOrderUpdate = () => {
    this._disposeReactionOrderUpdate?.()
    this._disposeReactionOrderUpdate = reaction(() => this.order, this.storeOrder)
  }

  reactionOrderRestore = () => {
    this._disposeReactionOrderRestore?.()
    this._disposeReactionOrderRestore = reaction(() => this._usersStore.user, this.restoreOrder)
  }
}
